module.exports = __webpack_public_path__ + "8721ea3f2acd2166ee2ba7ac86e7e3a6.fbx";